import * as angular from 'angular';
import { IValueViewModel, Pattern, ComponentDefinition } from '../../models/';
import { searchCriteria } from './identifier.searchCriteria';

class IdentifierSearchBarController implements angular.IComponentController {
    criteria: Pattern<IValueViewModel>[];
    displayChildren: boolean;
    filterable: IValueViewModel[];
    filtered: IValueViewModel[];
    searchString: string;
    sort: any;

    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.filtered = this.filterable;
        this.displayChildren = true;

        if (!this.searchString) {
            this.searchString = '';
        }

        this.criteria = searchCriteria;
    }

    toggleChildren(): void {
        this.displayChildren = !this.displayChildren;
    }
}

export const wtIdentifierSearchBar: ComponentDefinition = {
    componentId: 'wtIdentifierSearchBar',
    controller: IdentifierSearchBarController,
    template: require('./identifierSearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        filterable: '<',
        filtered: '=',
        searchString: '=?',
        sort: '<?',
        displayChildren: '='
    }
};
